import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    rounded-md
    bg-white
  `,
  slots: {
    card: `
      p-6`,
  },
});
